import axios from "axios";
import moment from "moment";
import querystring from "querystring";
import React, { useCallback, useEffect, useRef, useState } from "react";
// import Masonry, { ResponsiveMasonry } from "react-responsive-masonry"
import { EmailShareButton } from "react-share";
import MobileNav from "../RealEventsListing/MobileNav";
import ImagePage from "./ImagePage";
import Masonry from 'react-masonry-css'
import SimilarEvents from "./SimilarEvents";
var { Modal } = require("react-bootstrap");
const RealEventsImages = ({
  data,
  sessionData,
  submitHandleLike,
  handleLikeImage,
  likeId,
  pageType,
  loginPopup,
  searchImagesTags,
  tagsData,
  loadingTags,
  searchQueryText,
  searchImageText,
  handleScrollTop,
  similarEvents,
}) => {
  const [gallery, setGallery] = useState(false);
  const [shareSection, setShareSection] = useState();
  const [threeImgaes, setThreeImages] = useState([]);
  const [saveModal, setSaveModal] = useState();
  const [imageId, setImageId] = useState("");
  const [albumModalMobile, setAlbumModalMobile] = useState(false);
  const [albumModal, setAlbumModal] = useState(false);
  const [loadingNew, setLoadingNew] = useState(false);
  const [albumData, setAlbumData] = useState([]);
  const [albumName, setAlbumName] = useState("");
  const [loadingSingleImage, setLoadingSingleImage] = useState(false);
  const [pinkImage, setPinkImage] = useState("");
  // const [saveimageModal, setSaveImageModal] = useState(false);
  const [tagsSection, setTagsSection] = useState(false);
  const [tagName, setTagName] = useState(searchQueryText);
  const [tagTitle, setTagTitle] = useState(null);
  const [offSet, setOffSet] = useState(0);
  const [newImageInput, setNewImageInput] = useState("");
  const inputRef = useRef(null);
  const [gId, setGid] = useState("");
  const [imageIds, setImageIds] = useState([]);
  const [newTagName, setNewTagName] = useState(null);
  const [restaurantName, setRestaurantName] = useState("");
  const [tId, setTId] = useState(null);
  const handleGalleryModal = (id, name) => {
    setNewImageInput(name);
    setGid(id);
    setGallery(!gallery);
  };
  var settings = {
    infinite: false,
    centerMode: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipe: true,
    showFull: false,
    showLoader: false,
    dots: false,
    arrows: true,
  };
  useEffect(() => {
    let d = data !== undefined && data;
    let nData = similarEvents;
    let name;
    nData?.filter((name, i) => {
      if (name.id == d.detail?.id) {
        setRestaurantName(name.RestaurantName)
      }
    });
  }, [data, similarEvents]);
  const handleShareModal = (index) => {
    if (index == shareSection) {
      setShareSection(null);
    } else {
      setShareSection(index);
    }
  };
  const getThreeImages = () => {
    let dataa = data?.data;
    let newData = dataa?.length > 3 ? dataa.slice(0, 3) : dataa;
    let nData = newData?.map((d, i) => {
      return d.fileName;
    });
    setThreeImages(nData);
  };
  useEffect(() => {
    getThreeImages();
  }, [data]);

  const handleBothModals = (index) => {
    if (sessionData && "userName" in sessionData) {
      setImageId(index);
      setGid(index);
      if (window.innerWidth > 768) {
        handleSaveModal(index);
      } else {
        handleMobileAlbum();
      }
    } else {
      loginPopup(true);
    }
  };
  const handleSaveModal = (index) => {
    if (index == saveModal) {
      setSaveModal(null);
    } else {
      setSaveModal(index);
    }
  };
  const handleMobileAlbum = () => {
    setAlbumModalMobile(!albumModalMobile);
  };
  const handleImageSave = (albumId) => {
    setLoadingSingleImage(true);
    let likeUrl = `https://api.bookeventz.com/ImageTags/insertAlbumImage`;
    let formData = {
      album_id: albumId,
      image_attachment_id: imageId,
      if_active: 1,
    };

    try {
      axios
        .post(likeUrl, querystring.stringify(formData))
        .then((formUpdate) => {
          if (formUpdate.data?.success == true) {
            setLoadingSingleImage(false);
            handleBothModals();
            setPinkImage(albumId);
            setPinkImage(gId);
          }
        });
    } catch (err) {
      console.log(err, "error");
    }
  };
  const handleAlbum = () => {
    setAlbumModalMobile(false);
    setAlbumModal(!albumModal);
  };
  const createAlbum = () => {
    setLoadingNew(true);
    let url = `https://api.bookeventz.com/ImageTags/createImageTagAlbum`;
    let formData = {
      name: albumName,
      user_profile_id: sessionData?.user_profile_id,
      is_active: 1,
    };

    axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
      if (formUpdate.data?.success == true) {
        setLoadingNew(false);
        setAlbumModal(false);
        getUserAlbumList();
        handleBothModals();
      }
    });
    (error) => {
      console.log(error);
    };
  };

  const getUserAlbumList = () => {
    let userProfileId = sessionData?.user_profile_id ?? '';
    let url = `https://api.bookeventz.com/imageTags/getUsersAlbum?user_profile_id=${userProfileId}&is_active=1`;
    try {
      axios.get(url).then((res) => {
        setAlbumData(res.data.data);
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  useEffect(() => {
    setTimeout(() => {
      getUserAlbumList();
    }, 2000);
  }, [sessionData]);
  const saveSingleImage = (imageId) => {
    setLoadingSingleImage(true);
    let url = `https://api.bookeventz.com/ImageTags/insertImageWihoutAlbum`;
    let formData = {
      user_profile_id: sessionData?.user_profile_id,
      image_attachment_id: imageId,
      if_active: 1,
    };
    try {
      axios.post(url, querystring.stringify(formData)).then((formUpdate) => {
        if (formUpdate.data?.success == true) {
          setImageIds((current) => [...current, imageId]);
          setLoadingSingleImage(false);

          handleBothModals();
        }
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  const download = async (url, name) => {
    let link =
      "https://media.bookeventz.com/html/bookeventz.com/images/albums/" + url;
    const a = document.createElement("a");
    // const blob = new Blob([link], {type: "image/jpg"});
    // a.href = await URL.createObjectURL(blob);
    a.href = await toDataURL(link);
    a.download = name;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    return;
  };

  const toDataURL = (url) => {
    return fetch(url)
      .then((response) => {
        return response.blob();
      })
      .then((blob) => {
        return URL.createObjectURL(blob);
      });
  };
  const leftClick = useCallback(() => {
    inputRef?.current.slickPrev();
  }, []);

  const rightClick = useCallback(() => {
    inputRef?.current.slickNext();
  }, []);

  const handleKeypress = useCallback(
    (e) => {
      if (e.keyCode === 37) {
        leftClick();
      } else if (e.keyCode === 39) {
        rightClick();
      } else if (e.keyCode === 27) {
        openImageCarousel(false);
      }
    },
    [leftClick, rightClick]
  );

  useEffect(() => {
    document.addEventListener("keydown", handleKeypress);
    return () => document.removeEventListener("keydown", handleKeypress);
  }, [handleKeypress]);
  const getImages = (id, name) => {
    setNewTagName(name);
    setTagName(name);
    setTId(id);
    // setLoadingData(true);
    let url = `https://api.bookeventz.com/imageTags/getImagesByTags?tag_id=${id}&searchText=${tagName}&if_active=1&start=0&limit=30`;
    try {
      axios.get(url).then((res) => {
        setImagesData(res.data.data);
        // setLoadingData(false);
      });
    } catch (err) {
      console.log(err, "error");
    }
  };
  const setParams = (url, tag_id) => {
    history.pushState(
      {},
      "",
      "search?searchText=" +
      url +
      "&tag_id=" +
      tag_id +
      "&tag_title=" +
      tagTitle
    );
  };
  useEffect(() => {
    const onScroll = () => setOffSet(window.pageYOffset);
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
  }, []);
  const handleReload = () => {
    window.location.reload();
  };

  // console.log(data, "data");
  // console.log(similarEvents, "similarEvents");

  return (
    <div
      onKeyDown={(e) => {
        if (e.keyCode === 13) {
          handleReload();
        }
      }}
    >
      {offSet > 200 && (
        <MobileNav
          searchImagesTags={searchImagesTags}
          loadingTags={loadingTags}
          tagsData={tagsData}
          handleScrollTop={handleScrollTop}
          oName={data?.detail?.name}
        />
      )}
      <div id="product-top">
        <div id="top-s0">
          {threeImgaes?.length > 0 &&
            threeImgaes !== undefined &&
            threeImgaes?.map((t, i) => {
              return (
                <div>
                  <img
                    src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${t}`}
                    alt="Top image"
                    id="pro-img"
                  />
                </div>
              );
            })}
        </div>
        <div id="product-bottom">
          <div id="op0">
            <span id="one">{data?.detail?.name}</span>
            {data.detail && data.detail.eventDate !== "0000-00-00 00:00:00" && (
              <span id="two">
                {moment(data?.detail?.eventDate).format("Do MMMM YYYY")}
              </span>
            )}
          </div>
          <span id="one54">{restaurantName !== "" && restaurantName}</span>
          <div id="bto">
            <span id="two">
              Theme:{" "}
              {data?.detail?.theme !== null &&
                data?.detail?.theme !== undefined &&
                data?.detail?.theme !== "" &&
                data?.detail?.theme}
            </span>
            <a
              href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/${data?.detail?.uniqueLink}`}
              data-action="n/whatsapp/share"
              target="_blank"
            >
              <img src="../../media/sharePur.svg" alt="Pink share icon" />
            </a>
          </div>
        </div>
      </div>
      <div id="search-a">
        <div
          id="s-a-4"
          onKeyDown={(e) => {
            if (e.keyCode === 13) {
              setTagsSection(!tagsSection);
              getImages("", tagName);
            }
          }}
        >
          <img src="../../media/blackSearch.svg" alt="Black Search Icon" />
          <input
            type="text"
            value={tagName}
            defaultValue={searchQueryText}
            placeholder="Search"
            onChange={(e) => {
              searchImagesTags(e.target.value);
              setTagName(e.target.value);
              setParams(e.target.value, "");
            }}
            onFocus={() => {
              setTagsSection(true);
            }}
            onBlur={() => {
              setTimeout(() => {
                setTagsSection(false);
              }, 200);
            }}
          />
        </div>
        {tagsData.length > 0 && tagsSection == true && (
          <div id="tags-wrapper">
            <ul id="tags">
              {tagsData !== undefined &&
                tagsData.map((t, index) => (
                  <li
                    key={index}
                    onClick={() => {
                      getImages(t.id, t.name);
                      setTagName(t.name);
                      setParams(t.name, t.id);
                      setTagsSection(!tagsSection);
                    }}
                  >
                    {t.name}
                  </li>
                ))}
            </ul>
          </div>
        )}
      </div>
      <div
        id="images-section-actual"
        onClick={() => {
          if (shareSection !== null) {
            setShareSection(null);
          }
        }}
      >
        <div id="cards-container">

          <Masonry
            breakpointCols={3}
            className="my-masonry-grid"
            columnClassName="my-masonry-grid_column"
          >
            {data?.data?.map((d, i) => (
              <>
                <div id="img-wrapper-8">
                  {d.id == saveModal && (
                    <div id="create-al-new-modal">
                      {loadingSingleImage == true ? (
                        <>
                          <div id="loading9">
                            <img
                              src="../../media/Pino.svg"
                              alt="Loading image"
                            />
                          </div>
                        </>
                      ) : (
                        <>
                          <span id="sll">
                            <span onClick={() => saveSingleImage(d.id)}>
                              Save Image
                            </span>
                            <span
                              id="close-this-shit"
                              onClick={() => handleBothModals()}
                            >
                              <img
                                src="../../media/closo.svg"
                                alt="Close Icon"
                              />
                            </span>
                          </span>
                          {albumData.length > 0 && albumData !== undefined && (
                            <>
                              <span id="sl">Save to Album</span>
                              {albumData !== undefined &&
                                albumData?.map((a, i) => {
                                  return (
                                    <span
                                      id="wl"
                                      onClick={() => handleImageSave(a.id)}
                                    >
                                      {a.name}
                                    </span>
                                  );
                                })}
                            </>
                          )}
                          <div id="ddr"></div>
                          <span id="sl">Save Image in a New Album</span>
                          <div id="cAl" onClick={() => handleAlbum()}>
                            <span>
                              <img
                                src="../../media/plus.png"
                                alt="Pink Plus Icon"
                              />
                            </span>
                            Create Album
                          </div>
                        </>
                      )}
                    </div>
                  )}
                  <img
                    key={i}
                    src={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${d.fileName}`}
                    style={{ width: "100%", display: "block" }}
                    onClick={() => handleGalleryModal(d.id, d.fileName)}
                  />
                  <a
                    href={`https://media.bookeventz.com/html/bookeventz.com/images/albums/${d.fileName}`}
                    download={d.fileName}
                  >
                    <img
                      src="../../media/dLoad.svg"
                      alt="Plus Iocn"
                      id="LoadD"
                    />
                  </a>
                  <img
                    src={
                      imageIds?.includes(d.id)
                        ? "../../media/pHeart.svg"
                        : "../../media/wHeart.svg"
                    }
                    alt="Pink Heart Iocn"
                    id="HeartP"
                    className="HeartP"
                    onClick={() => handleBothModals(d.id)}
                  />
                  <img
                    src="../../media/sh.svg"
                    alt="Share Iocn"
                    id="Hs"
                    onClick={() => handleShareModal(d.id)}
                  />
                  {d.id == shareSection && (
                    <div id="share-wrapper">
                      <a
                        href={`https://api.whatsapp.com/send?text=https://www.bookeventz.com/real-events/image-page?imageText=${d.fileName}`}
                        data-action="share/whatsapp/share"
                        target="_blank"
                      >
                        <img src="../../media/watti.svg" alt="Whatsapp Image" />
                      </a>
                      {/* </WhatsappShareButton> */}
                      <EmailShareButton
                        subject={d.desc !== null ? d.desc : null}
                        url={`https://www.bookeventz.com/real-events/image-page?imageText=${d.fileName}`}
                      >
                        <img
                          src="../../media/gmail.svg"
                          alt="Gmail Image"
                          id="gmail-image"
                        />
                      </EmailShareButton>
                    </div>
                  )}
                </div>
                <p className="wed-desc">{d.desc}</p>
              </>
            ))}
          </Masonry>

        </div>
      </div>
      <SimilarEvents similarEvents={similarEvents} />
      <Modal
        dialogClassName={"gallery-modal"}
        show={gallery}
        onHide={handleGalleryModal}
        animation={false}
      >
        <ImagePage
          searchImageText={searchImageText}
          newImageInput={newImageInput}
          Modal={setGallery}
        />
      </Modal>
      <Modal
        dialogClassName={"mobile-album-create-modal"}
        show={albumModalMobile}
        onHide={handleMobileAlbum}
        animation={false}
      >
        <div id="create-al-new-modal-mobile">
          <span id="close-this-shit" onClick={() => handleMobileAlbum()}>
            <img src="../../media/closo.svg" alt="Close Iocn" />
          </span>
          <span id="sll" onClick={() => saveSingleImage(gId)}>
            Save Image
          </span>
          {albumData.length > 0 && albumData !== undefined && (
            <>
              <span id="sl">Save to Album</span>
              {albumData !== undefined &&
                albumData?.map((a, i) => {
                  return (
                    <span id="wl" onClick={() => handleImageSave(a.id)}>
                      {a.name}
                    </span>
                  );
                })}
            </>
          )}
          <div id="ddr"></div>
          <span id="sl">Save Image in a New Album</span>
          <div id="cAl">
            <span onClick={() => handleAlbum()}>
              <img src="../../media/pinkyH.svg" alt="Pink Plus Icon" />
            </span>
            Create Album
          </div>
        </div>
      </Modal>
      <Modal
        dialogClassName={"album-create-modal"}
        show={albumModal}
        onHide={handleAlbum}
        animation={false}
      >
        <div id="create-Album">
          {loadingNew == true ? (
            <>
              <div id="loading">
                <img src="../../media/Pino.svg" alt="Loading image" />
              </div>
            </>
          ) : (
            <>
              {" "}
              <input
                type="text"
                placeholder="Create Album"
                onChange={(e) => setAlbumName(e.target.value)}
              />
              <div id="bt87">
                <button onClick={() => handleAlbum()}>Cancel</button>
                <button onClick={() => createAlbum()}>Create</button>
              </div>
            </>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default RealEventsImages;
